var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"indicator indicator-wide indicator-darken\">\n    <span>\n        <i class=\"fa fa-random\"></i>\n        "
    + ((stack1 = __default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"title.diff.name",depth0,{"name":"i18n","hash":{},"data":data})) != null ? stack1 : "")
    + "\n    </span>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./system/ui/template/mode-indicator/diff.hbs
// module id = 1260
// module chunks = 0